import e from "react";
import { cls as n } from "../../../helpers/cls.js";
const i = t => e.createElement("span", {
  className: n({
    "olx-text-input__input-container": !0,
    "olx-text-input__input-container--hascontent": !!t.value,
    ["olx-text-input__input-container--".concat(t.state)]: t.state,
    "olx-text-input__input-container--medium": t.size === "medium",
    "olx-text-input__input-container--disabled": t.disabled
  })
}, t.children);
export { i as InputGroup };